import Profile from "./profile";

const Partners = {
  Profile: Profile
};

export default Partners;
